import { Heading } from "@planningcenter/doxy-web"
import Connected from "./components/Connected"
import Disconnected from "./components/Disconnected"
import { Text2GivePhoneNumber } from "../types"
import { useGivingPersonContext } from "../hooks/useGivingPersonContext"
import useNotifyNativeLoaded from "source/shared/hooks/useNotifyNativeLoaded"
import NativeHeader from "source/shared/NativeHeader"

export default function Text2Give() {
  const { givingPerson } = useGivingPersonContext()
  const text2GivePhoneNumber: Text2GivePhoneNumber | null =
    givingPerson.text_to_give_phone_number

  useNotifyNativeLoaded()

  return (
    <>
      <NativeHeader title="Text2Give" />
      <section>
        <div className="mb-2 d-n d-f@md">
          <Heading level={1} size={2} text="Text2Give" />
        </div>
        {text2GivePhoneNumber?.registration_completed ? (
          <Connected />
        ) : (
          <Disconnected />
        )}
      </section>
    </>
  )
}
